<template>
  <div>
    <v-row>
      <v-col cols="2">
        <div v-if="doc.archetype && doc.archetype.length" class="grey-darken">
          <div
            id="drag-1"
            class="drag-el"
            draggable
            @dragstart="startDrag($event, doc.archetype[0].name)"
            @drop="onDrop($event, 1)"
            @dragover.prevent
            @dragenter.prevent
            data-title="start"
          >
            <v-card class="mx-auto card--fade" light>
              <v-img class="white--text align-end" :src="doc.archetype[0].src">
              </v-img>
              <v-card-title>{{ doc.archetype[0].name }}</v-card-title>
            </v-card>
          </div>
        </div>

        <h2
          v-text="$t('exercise_archetypes.step2.title')"
          class="headline mt-10"
        ></h2>

        <p
          v-for="(item, index) in $t('exercise_archetypes.step2.description')"
          :key="index"
          v-text="item"
          class="mt-5"
        />
      </v-col>
      <v-col cols="10">
        <div class="archetypes" v-if="types">
          <div
            v-for="item in types"
            :key="item.title"
            :style="{ backgroundColor: item.color }"
            class="archetype"
            :id="item.id"
            @drop="onDrop($event, 1)"
            @dragover.prevent
            @dragenter.prevent
            :data-title="item.title"
            :data-id="item.id"
          >
            <archetypes-card @selectNote="selectNote" :item="item">
            </archetypes-card>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import ArchetypesCard from "./ArchetypesCard";

export default {
  name: "ArchetypesTable",
  props: {
    doc: Object,
    value: Object,
    exercise: Object,
  },
  components: {
    ArchetypesCard,
  },
  data() {
    return {
      type: this.value,
      types: this.$t("exercise_archetypes.types"),
      list1: this.doc.archetype,
      selectedItems: [],
    };
  },
  watch: {
    type: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.item = val;
    },
    exercise(val) {
      if (val) {
        this.$nextTick(() => {
          if (val.doc && val.doc.type && val.doc.type.id) {
            this.assignArchetype();
          }
        });
      }
    },
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    assignArchetype() {
      let clip = document.getElementById("drag-1");
      console.log("clip", clip);
      let div = document.getElementById(this.exercise.doc.type.id);
      console.log("div", div);
      let target = div.getElementsByClassName("dropTarget")[0];
      console.log("target", target);
      target.appendChild(clip);
    },
    selectNote(id, active) {
      if (active == true) {
        if (!this.selectedItems.some((item) => item === id)) {
          this.selectedItems.push(id);
        }
      } else {
        let indexOfItem = this.selectedItems.indexOf(id);
        this.selectedItems.splice(indexOfItem, 1);
      }
    },
    startDrag: (ev) => {
      ev.dataTransfer.setData("text", ev.target.id);
      ev.dataTransfer.dropEffect = "move";
      ev.dataTransfer.effectAllowed = "move";
    },
    onDrop(ev) {
      var data = ev.dataTransfer.getData("text");
      let div = document.getElementById(ev.target.dataset.id);
      let target = div.getElementsByClassName("dropTarget")[0];
      target.appendChild(document.getElementById(data));
      this.type = { title: ev.target.dataset.title, id: ev.target.dataset.id };
    },
    showInfo(item) {
      item.selected = true;
    },
  },
};
</script>

<style lang="scss">
.archetypes {
  display: flex;
  flex-wrap: wrap;
}
.drag-el {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}
.card-holder {
  width: 25%;
}
.archetype {
  height: 500px;
  overflow: hidden;
  width: 33.33%;
  padding: 0.5rem;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  cursor: move;
  .overline {
    margin-bottom: 0px;
  }
  .help {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
  .v-card {
    width: 300px !important;
  }
}
</style>
